<template>
  <div
    id="init-home-container"
    class="d-flex flex-row justify-center"
    style="width: 100%"
    v-if="show"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!--<auth></auth>-->

    <v-main id="supermain" style="">
      <v-container class="white black--text" id="home-container">
        <v-card class="mx-auto mt-4" max-width="384" color="grey lighten-5">
          <v-card-title>Compliment</v-card-title>
          <v-card-text>
            You can send a compliment to Reno Police Department Internal Affairs
            Divsion by filling out the required form, which is available in
            English and Spanish. We will pass along the compliment to the
            respective employee and/or department.
          </v-card-text>
          <v-card-text>
            Puede enviar un cumplido a la División de Asuntos Internos del
            Departamento de Policía de Reno rellenando el formulario requerido,
            que está disponible en inglés y español. Transmitiremos el cumplido
            al empleado y/o departamento correspondiente.
          </v-card-text>
          <v-card-actions>
            <div class="d-flex justify-center" style="width: 100%">
              <v-btn
                small
                class="white--text"
                color="accent"
                @click="go_comment"
              >
                Fill Out Form
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
        <v-card
          class="mx-auto mt-4 pb-4"
          max-width="384"
          color="grey lighten-5"
        >
          <v-card-title>Complaint</v-card-title>
          <v-card-text>
            You can file a complaint with Reno Police Department Internal
            Affairs Divsion by filling out the required form, which is available
            in English and Spanish.
          </v-card-text>
          <v-card-text>
            Puede presentar una queja ante la División de Asuntos Internos del
            Departamento de Policía de Reno rellenando el formulario requerido,
            disponible en inglés y español.
          </v-card-text>
          <v-card-actions>
            <div class="d-flex justify-center" style="width: 100%">
              <v-btn
                small
                class="white--text"
                color="accent"
                @click="go_complaint"
              >
                Fill Out Form
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    max-width: 768px;
    min-height: 84dvh;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  // #home-container {
  //   *margin-left: 8px;*
  // }
}

@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  components: {},
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      show: false,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    go_complaint() {
      this.$router.push("/complaint");

      //Please do not use this to report a crime or file a police report. Go here to file a report
    },
    go_comment() {
      this.$router.push("/comment");
    },
    init(self) {
      //document.getElementById("vapp").style.overflowY = "hidden";
      this.show_loader(false);
      this.swall_diag(
        "IMPORTANT: PLEASE READ",
        "If you have an emergency please call or text 911.<br><br>Are you attempting to report a crime or file a police report online?",
        "warning",
        function () {
          window.open("https://www.renopd.com/report", "_self");
        },
        "Yes",
        "No",
        function () {
          self.show = true;
          //this.show = true;
        }
      );
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
